import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {getDashboardLanguage} from '../helper/general.helper';
import {resolveUserAndAccount} from '../helper/auth-resolve.helper';
import {IVjHistoryStore, VjHistoryStore, VjHistoryUrlParams} from './vj-history.stores';

const trace = getAppTracer('vj-history.loader');

export async function vjHistoryRouteLoader(args: LoaderFunctionArgs): Promise<IVjHistoryStore | void> {
    trace.info('Starting');
    const rootStore = getRootStore();
    const url = new URL(args.request.url);
    const params = url.searchParams;
    const redirectParams = Object.fromEntries(params.entries());

    const {accountData} = await resolveUserAndAccount({redirectParams});

    const localizationService = rootStore.localizationService;
    if (!localizationService.isInitialized()) {
        const accountLanguage = getDashboardLanguage(accountData);
        localizationService.setAccountData(accountData._id, accountLanguage);
        await localizationService.init();
    }

    const urlParams: VjHistoryUrlParams = {
        customerRef: params.get('r') ?? undefined,
        startDate: params.get('startDate') ?? undefined,
        endDate: params.get('endDate') ?? undefined,
        roomId: params.get('roomId') ?? undefined,
        isEmbedded: params.get('emb') === 'true' || params.get('is')?.toLowerCase() === 'vjhistory'
    };

    const store = new VjHistoryStore(accountData, urlParams);

    trace.info('Completed successfully');
    return store;
}
